import en from './messages-en.json'

export const translations: any = { en }
